/**
 * 4Kidz Shopify theme — storefront script (no dependencies)
 * Nav & drawer · scroll reveal · language menu · variant picker · gallery ·
 * quantity steppers · cart auto-update · T&C tabs · YouTube on click · sticky buy bar
 */
(function () {
  'use strict';

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('k4-config').textContent); } catch (e) {}

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ── Money (uses the shop's money format, e.g. "CHF {{amount}}") ── */
  function formatMoney(cents, format) {
    format = format || cfg.moneyFormat || '{{amount}}';
    var value = (cents / 100);
    function fmt(n, dec, thou, sep) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + sep + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        default: return fmt(value, 2, ',', '.');
      }
    });
  }

  /* ── Nav + mobile drawer ── */
  function initNav() {
    var nav = $('#nav-4k');
    if (nav) {
      var ticking = false;
      var onScroll = function () { nav.classList.toggle('scrolled', window.pageYOffset > 10); ticking = false; };
      window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
      onScroll();
    }
    var menu = $('#mobile-menu-4k'), overlay = $('#mobile-menu-overlay'), btn = $('#nav-hamburger');
    if (!menu || !btn) return;
    function open() {
      menu.hidden = false; overlay.hidden = false;
      requestAnimationFrame(function () { menu.classList.add('open'); overlay.classList.add('open'); });
      document.body.classList.add('menu-open'); btn.setAttribute('aria-expanded', 'true');
      setTimeout(function () { var c = $('#mobile-menu-close'); if (c) c.focus(); }, 50);
    }
    function close() {
      if (!menu.classList.contains('open')) return;
      menu.classList.remove('open'); overlay.classList.remove('open');
      document.body.classList.remove('menu-open'); btn.setAttribute('aria-expanded', 'false'); btn.focus();
      setTimeout(function () { menu.hidden = true; overlay.hidden = true; }, 330);
    }
    btn.addEventListener('click', open);
    [$('#mobile-menu-close'), overlay].forEach(function (el) { if (el) el.addEventListener('click', close); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', function () { if (window.innerWidth > 920) close(); });
  }

  /* ── Scroll reveal ── */
  function initReveal() {
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window) || document.documentElement.classList.contains('shopify-design-mode')) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
    }, { threshold: 0.1 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ── Language dropdown: close on outside click / Esc ── */
  function initLang() {
    document.addEventListener('click', function (e) {
      $$('details.k4-lang[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('details.k4-lang[open]').forEach(function (d) { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.focus(); });
    });
  }

  /* ── Quantity steppers (product form + cart) ── */
  function initQty() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-k4-qty]');
      if (!b) return;
      var input = b.parentNode.querySelector('input[type="number"]');
      if (!input) return;
      var min = parseInt(input.min || '0', 10), v = parseInt(input.value || '0', 10) + parseInt(b.getAttribute('data-k4-qty'), 10);
      input.value = Math.max(min, v);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    // Cart: update automatically after a short pause
    var t;
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-k4-cart-qty]')) return;
      clearTimeout(t);
      var form = e.target.form;
      t = setTimeout(function () {
        var u = form.querySelector('button[name="update"]');
        if (form.requestSubmit && u) form.requestSubmit(u); else if (u) u.click();
      }, 700);
    });
  }

  /* ── Gallery ── */
  function setMainImage(scope, src) {
    var img = (scope || document).querySelector('#main-img-4k') || $('#main-img-4k');
    if (!img || !src) return;
    img.classList.add('switching');
    setTimeout(function () {
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.src = src; img.classList.remove('switching');
    }, 200);
  }
  function initGallery() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('.thumb-4k[data-full]');
      if (!t) return;
      setMainImage(t.closest('.gallery-4k'), t.getAttribute('data-full'));
      $$('.thumb-4k', t.parentNode).forEach(function (x) { x.classList.toggle('active', x === t); });
    });
  }

  /* ── Variant picker (design buttons) ── */
  function initProducts() {
    $$('[data-k4-product]').forEach(function (box) {
      if (box.getAttribute('data-k4-ready')) return;
      box.setAttribute('data-k4-ready', '1');
      var json = box.querySelector('[data-k4-variants]');
      var form = box.querySelector('[data-k4-form]');
      if (!json || !form) return;
      var variants = [];
      try { variants = JSON.parse(json.textContent); } catch (e) { return; }
      var idInput = form.querySelector('[data-k4-variant-id]');
      var addBtn = form.querySelector('[data-k4-add]');
      var addText = form.querySelector('[data-k4-add-text]');
      var priceEl = box.querySelector('[data-k4-price]');
      var scope = box.closest('section, .k4-single, .product-inner-4k') || document;
      var sets = $$('[data-k4-option]', form);

      function selected() {
        return sets.map(function (fs) { var a = fs.querySelector('.variant-btn-4k.active'); return a ? a.getAttribute('data-value') : null; });
      }
      function find(values) {
        return variants.find(function (v) { return v.options.every(function (o, i) { return values[i] === null || o === values[i]; }); });
      }
      function update() {
        var v = find(selected());
        if (!v) {
          if (addBtn) addBtn.disabled = true;
          if (addText) addText.textContent = cfg.unavailable || '';
          return;
        }
        idInput.value = v.id;
        if (addBtn) addBtn.disabled = !v.available;
        if (addText) addText.textContent = v.available ? (cfg.addToCart || addText.textContent) : (cfg.soldOut || '');
        if (priceEl) {
          priceEl.innerHTML = (v.compare_at_price > v.price ? '<s class="price-old-4k">' + formatMoney(v.compare_at_price) + '</s> ' : '') + formatMoney(v.price);
        }
        if (v.featured_image && v.featured_image.src) {
          setMainImage(scope, v.featured_image.src);
          $$('.thumb-4k', scope).forEach(function (t) { t.classList.toggle('active', String(t.getAttribute('data-media-id')) === String(v.featured_media && v.featured_media.id)); });
        }
        if (document.body.classList.contains('template-product') && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        // Mark design buttons that lead to sold-out variants
        sets.forEach(function (fs, idx) {
          $$('.variant-btn-4k', fs).forEach(function (b) {
            var vals = selected(); vals[idx] = b.getAttribute('data-value');
            var m = find(vals);
            b.classList.toggle('is-unavailable', !m || !m.available);
          });
        });
      }
      sets.forEach(function (fs) {
        fs.addEventListener('click', function (e) {
          var b = e.target.closest('.variant-btn-4k');
          if (!b) return;
          $$('.variant-btn-4k', fs).forEach(function (x) { var on = x === b; x.classList.toggle('active', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
          var lbl = fs.querySelector('.active-variant-label');
          if (lbl) lbl.textContent = b.getAttribute('data-label') || b.getAttribute('data-value');
          update();
        });
      });
      // The no-JS <select> is not needed once JavaScript runs
      $$('noscript', form).forEach(function (n) { n.remove(); });
    });
  }

  /* ── Terms & Conditions tabs ── */
  function activateTab(wrap, lang) {
    var tab = wrap.querySelector('.terms-tab-4k[data-lang="' + lang + '"]');
    if (!tab) return false;
    $$('.terms-tab-4k', wrap).forEach(function (t) { var on = t === tab; t.classList.toggle('active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
    $$('.terms-panel-4k', wrap).forEach(function (p) { p.classList.toggle('active', p.id === tab.getAttribute('aria-controls')); });
    return true;
  }
  function initTerms() {
    $$('.terms-tabs-4k').forEach(function (wrap) {
      wrap.classList.add('js-ready');
      var hash = (location.hash || '').replace('#', '').toLowerCase();
      if (!activateTab(wrap, hash)) activateTab(wrap, wrap.getAttribute('data-default-lang') || 'de');
    });
    document.addEventListener('click', function (e) {
      var t = e.target.closest('.terms-tab-4k');
      if (!t) return;
      activateTab(t.closest('.terms-tabs-4k'), t.getAttribute('data-lang'));
      if (history.replaceState) history.replaceState(null, '', '#' + t.getAttribute('data-lang'));
    });
  }

  /* ── YouTube: load the player only after a click ── */
  function initYouTube() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.k4-yt-play');
      if (!a) return;
      var box = a.closest('.k4-yt');
      if (!box || !box.getAttribute('data-src')) return;
      e.preventDefault();
      var f = document.createElement('iframe');
      f.src = box.getAttribute('data-src');
      f.title = box.getAttribute('data-title') || 'YouTube';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      f.allowFullscreen = true;
      f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      box.innerHTML = ''; box.classList.add('is-playing'); box.appendChild(f);
    });
  }

  /* ── Sticky buy bar (product page, mobile) ── */
  function initBuyBar() {
    var bar = $('#k4-buybar'), form = $('.k4-single-summary [data-k4-form]');
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.bottom < 0); });
    }).observe(form);
    var b = bar.querySelector('.k4-buybar-btn');
    if (b) b.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: form.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
    });
  }

  function boot() {
    initNav(); initReveal(); initLang(); initQty(); initGallery(); initProducts(); initTerms(); initYouTube(); initBuyBar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor: re-run when sections are added or changed
  document.addEventListener('shopify:section:load', function () { initReveal(); initProducts(); initTerms(); });
})();
